// Dynamic Shopify Subscription Toggle + Dropdown
// Automatically extracts all data from existing subscription widget

document.addEventListener('DOMContentLoaded', function() {
  
  function createDynamicToggleUI() {
    const subscriptionContainer = document.querySelector('.shopify_subscriptions_app_container');
    
    if (!subscriptionContainer) return;
    
    // Extract data from original widget
    const widgetData = extractWidgetData();
    
    if (!widgetData.oneTime && !widgetData.subscriptions.length) {
      console.log('No subscription data found');
      return;
    }
    
    // Hide the original subscription widget
    const originalWidget = subscriptionContainer.querySelector('.shopify_subscriptions_app_block');
    if (originalWidget) {
      originalWidget.style.display = 'none';
    }
    
    // Create new toggle interface with dynamic data
    const toggleInterface = document.createElement('div');
    toggleInterface.className = 'custom-subscription-toggle';
    toggleInterface.innerHTML = createToggleHTML(widgetData);
    
    // Insert the new interface before the original widget
    subscriptionContainer.insertBefore(toggleInterface, originalWidget);
    
    // Add event listeners
    addToggleEventListeners(widgetData);
    addDropdownEventListener();
    
    // Set initial state to subscription if available, otherwise one-time
    if (widgetData.subscriptions.length > 0) {
      updateOriginalWidget('subscription', widgetData.subscriptions[0].sellingPlanId);
      // Set subscription as active by default
      setTimeout(() => {
        const subscriptionBtn = document.querySelector('[data-option="subscription"]');
        if (subscriptionBtn) {
          subscriptionBtn.click();
        }
      }, 100);
    } else {
      updateOriginalWidget('one-time');
    }
  }
  
  function extractWidgetData() {
    const data = {
      oneTime: null,
      subscriptions: []
    };
    
    // Extract one-time purchase data
    const oneTimeRadio = document.querySelector('[data-radio-type="one_time_purchase"]');
    if (oneTimeRadio) {
      data.oneTime = {
        price: oneTimeRadio.getAttribute('data-variant-price') || 'N/A',
        label: oneTimeRadio.closest('label').textContent.trim()
      };
    }
    
    // Extract subscription data
    const subscriptionRadios = document.querySelectorAll('[data-radio-type="selling_plan"]');
    subscriptionRadios.forEach(radio => {
      const label = radio.closest('label').textContent.trim();
      const price = radio.getAttribute('data-variant-price');
      const comparePrice = radio.getAttribute('data-variant-compare-at-price');
      const sellingPlanId = radio.getAttribute('data-selling-plan-id');
      
      // Calculate discount percentage if both prices exist
      let discountPercent = null;
      if (price && comparePrice) {
        const currentPrice = parseFloat(price.replace(/[^0-9.]/g, ''));
        const originalPrice = parseFloat(comparePrice.replace(/[^0-9.]/g, ''));
        if (originalPrice > currentPrice) {
          discountPercent = Math.round(((originalPrice - currentPrice) / originalPrice) * 100);
        }
      }
      
      data.subscriptions.push({
        label: label,
        price: price || 'N/A',
        comparePrice: comparePrice,
        sellingPlanId: sellingPlanId,
        discountPercent: discountPercent
      });
    });
    
    return data;
  }
  
  function createToggleHTML(widgetData) {
    // Get subscription price (use first subscription's price)
    const subscriptionPrice = widgetData.subscriptions.length > 0 ? widgetData.subscriptions[0].price : 'N/A';
    const comparePrice = widgetData.subscriptions.length > 0 ? widgetData.subscriptions[0].comparePrice : null;
    const discountPercent = widgetData.subscriptions.length > 0 ? widgetData.subscriptions[0].discountPercent : null;
    
    // Create subscription options for dropdown
    const subscriptionOptions = widgetData.subscriptions.map(sub => 
      `<option value="${sub.sellingPlanId}">${sub.label}</option>`
    ).join('');
    
    return `
      <div class="purchase-option-toggle">
        ${widgetData.subscriptions.length > 0 ? `
        <div class="toggle-option subscription-option active" data-option="subscription">
          <div class="option-header">
            <div class="radio-container">
              <input type="radio" name="purchase-type" value="subscription" checked>
              <div class="option-content">
                <span class="option-title">Subscribe and Save</span>
                ${discountPercent ? `<span class="discount-badge">${discountPercent}% off</span>` : ''}
              </div>
            </div>
            <div class="price-container">
              ${comparePrice ? `<span class="original-price">${comparePrice}</span>` : ''}
              <span class="current-price">${subscriptionPrice}</span>
            </div>
          </div>
          <div class="option-details">
            <hr class="separator">
            <div class="benefits-and-frequency">
              <div class="benefits-section">
                <div class="benefits-list">
                  <span class="benefit">• Save ${discountPercent || ''}% on every order</span>
                  <span class="benefit">• Free Shipping</span>
                  <span class="benefit">• Cancel or pause anytime</span>
                </div>
              </div>
              <div class="frequency-section">
                <select id="frequency-select" class="frequency-dropdown">
                  ${subscriptionOptions}
                </select>
              </div>
            </div>
          </div>
        </div>
        ` : ''}
        
        ${widgetData.oneTime ? `
        <div class="toggle-option onetime-option" data-option="one-time">
          <div class="option-header">
            <div class="radio-container">
              <input type="radio" name="purchase-type" value="one-time">
              <div class="option-content">
                <span class="option-title">One-Time Purchase</span>
              </div>
            </div>
            <div class="price-container">
              <span class="current-price">${widgetData.oneTime.price}</span>
            </div>
          </div>
        </div>
        ` : ''}
      </div>
    `;
  }
  
  function addToggleEventListeners(widgetData) {
    const toggleOptions = document.querySelectorAll('.toggle-option');
    
    toggleOptions.forEach(option => {
      const radioInput = option.querySelector('input[type="radio"]');
      
      // Add click listener to the entire option
      option.addEventListener('click', function() {
        // Remove active class from all options
        toggleOptions.forEach(opt => opt.classList.remove('active'));
        
        // Add active class to clicked option
        this.classList.add('active');
        
        // Check the radio button
        radioInput.checked = true;
        
        const optionType = this.getAttribute('data-option');
        
        if (optionType === 'subscription') {
          // Update original widget to first subscription option
          const firstFrequencySelect = document.querySelector('#frequency-select');
          if (firstFrequencySelect && widgetData.subscriptions.length > 0) {
            const firstFrequency = firstFrequencySelect.value || widgetData.subscriptions[0].sellingPlanId;
            updateOriginalWidget('subscription', firstFrequency);
          }
        } else {
          // Update original widget to one-time purchase
          updateOriginalWidget('one-time');
        }
      });
      
      // Also add listener to radio input directly
      radioInput.addEventListener('change', function() {
        if (this.checked) {
          option.click();
        }
      });
    });
  }
  
  function addDropdownEventListener() {
    const frequencySelect = document.querySelector('#frequency-select');
    
    if (frequencySelect) {
      frequencySelect.addEventListener('change', function(e) {
        e.stopPropagation(); // Prevent triggering parent click
        const selectedFrequency = this.value;
        updateOriginalWidget('subscription', selectedFrequency);
      });
    }
  }
  
  function updateOriginalWidget(purchaseType, sellingPlanId = null) {
    const originalWidget = document.querySelector('.shopify_subscriptions_app_block');
    
    if (purchaseType === 'one-time') {
      // Select one-time purchase radio button
      const oneTimeRadio = originalWidget.querySelector('[data-radio-type="one_time_purchase"]');
      if (oneTimeRadio) {
        oneTimeRadio.checked = true;
        oneTimeRadio.dispatchEvent(new Event('change'));
      }
      
      // Clear selling plan
      const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput) sellingPlanInput.value = '';
      
    } else if (purchaseType === 'subscription' && sellingPlanId) {
      // Select specific subscription radio button
      const subscriptionRadio = originalWidget.querySelector(`[data-selling-plan-id="${sellingPlanId}"]`);
      if (subscriptionRadio) {
        subscriptionRadio.checked = true;
        subscriptionRadio.dispatchEvent(new Event('change'));
      }
      
      // Update selling plan
      const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
      if (sellingPlanInput) sellingPlanInput.value = sellingPlanId;
    }
  }
  
  // Add custom CSS styles
  function addCustomStyles() {
    const style = document.createElement('style');
    style.textContent = `
      .custom-subscription-toggle {
        font-family: inherit;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        overflow: hidden;
      }
      
      .toggle-option {
        border-bottom: 1px solid #e0e0e0;
        background: white;
        cursor: pointer;
        transition: all 0.2s ease;
      }
      
      .toggle-option:last-child {
        border-bottom: none;
      }
      
      .toggle-option:hover {
        background: #f8f9ff;
      }
      
      .toggle-option.active {
        background: #f8f9ff;
        border-color: #007bff;
      }
      
      .option-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px;
      }
      
      .radio-container {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;
      }
      
      .radio-container input[type="radio"] {
        margin: 0;
        width: 18px;
        height: 18px;
        cursor: pointer;
      }
      
      .option-content {
        display: flex;
        align-items: center;
        gap: 10px;
      }
      
      .option-title {
        font-weight: 500;
        color: #333;
        font-size: 16px;
      }
      
      .discount-badge {
        background: #007bff;
        color: white;
        padding: 2px 8px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;
      }
      
      .price-container {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      
      .original-price {
        text-decoration: line-through;
        color: #999;
        font-size: 14px;
      }
      
      .current-price {
        font-weight: 600;
        color: #333;
        font-size: 16px;
      }
      
      .option-details {
        padding: 0 15px 15px 15px;
      }
      
      .separator {
        border: none;
        border-top: 1px solid #e0e0e0;
        margin: 0 0 15px 0;
      }
      
      .benefits-and-frequency {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 20px;
      }
      
      .benefits-section {
        flex: 1;
      }
      
      .benefits-list {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      
      .benefit {
        color: #28a745;
        font-size: 14px;
      }
      
      .frequency-section {
        min-width: 120px;
      }
      
      .frequency-dropdown {
        width: 100%;
        padding: 8px 12px 8px 12px;
        padding-right: 35px;
        border: 1px solid #ddd;
        border-radius: 4px;
        background: white;
        font-size: 14px;
        cursor: pointer;
        appearance: none;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
        background-position: right 12px center;
        background-repeat: no-repeat;
        background-size: 16px;
      }
      
      .frequency-dropdown:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
      }
      
      /* Hide original widget */
      .shopify_subscriptions_app_block {
        display: none !important;
      }
      
      /* Show details only for active subscription option */
      .toggle-option:not(.active) .option-details {
        display: none;
      }
      
      .subscription-option.active .option-details {
        display: block;
      }
      
      /* Responsive design */
      @media (max-width: 600px) {
        .benefits-and-frequency {
          flex-direction: column;
          gap: 15px;
        }
        
        .frequency-section {
          min-width: auto;
          width: 100%;
        }
        
        .option-header {
          padding: 15px 12px;
          gap: 12px;
        }
        
        .option-content {
          gap: 8px;
        }
        
        .option-details {
          padding: 0 12px 12px 12px;
        }
      }
    `;
    document.head.appendChild(style);
  }
  
  // Initialize everything
  createDynamicToggleUI();
  addCustomStyles();
});

/* 
This code automatically:
- Creates a stacked layout with subscription on top, one-time below
- Places prices on the right side of each option
- Shows benefits and dropdown in the same block for subscription option
- Extracts prices from your existing subscription widget
- Gets all subscription options and frequencies
- Calculates discount percentages
- Works with any subscription setup without hardcoding
*/